<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :vislbleAlert="true"
    />

    <!-- 대상 정보 -->
    <div class="mb-8">
      <div class="mb-4">
        <div>
          <h5><i class="dot"></i>대상 정보</h5>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div style="word-break: keep-all;">업체명</div>
          <div>
            <company-selector v-model="form.대상정보.업체명.id" :company-name="form.대상정보.업체명.com_name" @select="(company) => {onSelectCompany(company)}"/>
          </div>
        </div>
        <div>
          <div style="word-break: keep-all;">사업자등록번호</div>
          <div>
            <ml-input v-model="form.대상정보.사업자등록번호" readonly/>
          </div>
        </div>
        <div>
          <div style="word-break: keep-all;">재해건수(전년도)</div>
          <div>
            <ml-input v-model="form.대상정보.재해건수" />
          </div>
        </div>
        <div>
          <div style="word-break: keep-all;">안전자격제 통과여부</div>
          <div>
            <radio-group :items="[
              { label: '통과(@08)', value: '@08'},
              { label: '미통과(@0A)', value: '@0A'},
              ]" flex v-model="form.대상정보.안전자격제통과여부"/>
          </div>
        </div>
        <div>
          <div style="word-break: keep-all;">승인여부</div>
          <div>
            <ml-input :value="form.대상정보.승인여부" readonly/>
          </div>
        </div>
      </div>
    </div>

    <!-- 필수 제출서류 -->
    <div class="mb-8">
      <div class="mb-4">
        <div>
          <h5><i class="dot"></i>필수 제출서류</h5>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div style="word-break: keep-all;">중대재해발생여부<br>확인서</div>
          <div>
            <radio-group :items="[
              { label: '통과(@08)', value: '@08'},
              { label: '미통과(@0A)', value: '@0A'},
              { label: '해당없음(@EB@)', value: '@EB@'},
              ]" flex v-model="form.필수제출서류.중대재해발생여부확인서"/>
          </div>
        </div>

        <div>
          <div style="word-break: keep-all;">원천징수이행상황<br>신고서</div>
          <div>
            <radio-group :items="[
              { label: '통과(@08)', value: '@08'},
              { label: '미통과(@0A)', value: '@0A'},
              { label: '해당없음(@EB@)', value: '@EB@'},
              ]" flex v-model="form.필수제출서류.원천징수이행상황신고서"/>
          </div>
        </div>

        <div>
          <div style="word-break: keep-all;">산재요양승인반려<br>여부확인서</div>
          <div>
            <radio-group :items="[
              { label: '통과(@08)', value: '@08'},
              { label: '미통과(@0A)', value: '@0A'},
              { label: '해당없음(@EB@)', value: '@EB@'},
              ]" flex v-model="form.필수제출서류.산재요양승인반려여부확인서"/>
          </div>
        </div>

        <div>
          <div style="word-break: keep-all;">안전보건조직도</div>
          <div>
            <radio-group :items="[
              { label: '통과(@08)', value: '@08'},
              { label: '미통과(@0A)', value: '@0A'},
              { label: '해당없음(@EB@)', value: '@EB@'},
              ]" flex v-model="form.필수제출서류.안전보건조직도"/>
          </div>
        </div>

        <div>
          <div style="word-break: keep-all;">안전보건경영방침</div>
          <div>
            <radio-group :items="[
              { label: '통과(@08)', value: '@08'},
              { label: '미통과(@0A)', value: '@0A'},
              { label: '해당없음(@EB@)', value: '@EB@'},
              ]" flex v-model="form.필수제출서류.안전보건경영방침"/>
          </div>
        </div>

        <div>
          <div style="word-break: keep-all;">안전보건관리규정</div>
          <div>
            <radio-group :items="[
              { label: '통과(@08)', value: '@08'},
              { label: '미통과(@0A)', value: '@0A'},
              { label: '해당없음(@EB@)', value: '@EB@'},
              ]" flex v-model="form.필수제출서류.안전보건관리규정"/>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import {required} from "vuelidate/lib/validators";
import NumberInput from "@/components/NumberInput.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  components: {
    RadioGroup,
    CompanySelector,
    NumberInput,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        대상정보: {
          업체명: {},
          사업자등록번호: '',
          재해건수: '',
          안전자격제통과여부: '',
          승인여부: '미승인',
        },
        필수제출서류: {
          중대재해발생여부확인서: '',
          원천징수이행상황신고서: '',
          산재요양승인반려여부확인서: '',
          안전보건조직도: '',
          안전보건경영방침: '',
          안전보건관리규정: '',
        }
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {

        // 승인여부가 중요한 데이터라고 판단하여, 승인 여부를 계산하여 넣어줌
        let 승인_count = 0;

        if (["@08", "@EB@"].indexOf(value.대상정보.안전자격제통과여부) >= 0) 승인_count++;
        if (["@08", "@EB@"].indexOf(value.필수제출서류.중대재해발생여부확인서) >= 0) 승인_count++;
        if (["@08", "@EB@"].indexOf(value.필수제출서류.원천징수이행상황신고서) >= 0) 승인_count++;
        if (["@08", "@EB@"].indexOf(value.필수제출서류.산재요양승인반려여부확인서) >= 0) 승인_count++;
        if (["@08", "@EB@"].indexOf(value.필수제출서류.안전보건조직도) >= 0) 승인_count++;
        if (["@08", "@EB@"].indexOf(value.필수제출서류.안전보건경영방침) >= 0) 승인_count++;
        if (["@08", "@EB@"].indexOf(value.필수제출서류.안전보건관리규정) >= 0) 승인_count++;
        value.대상정보.승인여부 = 승인_count === 7 ? "승인" : "미승인";

        this.$emit("input", value);
      },
    },
  },
  created() {
  },
  methods: {
    onSelectCompany (company) {
      this.form.대상정보.업체명 = company;
      this.form.대상정보.사업자등록번호 = company.com_number;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
